import { ComponentRendering } from '@sitecore-jss/sitecore-jss-react';
import {
  ProductSeriesDetailMosaicMediaGalleryAsset,
  ProductSeriesDetailMosaicMediaGalleryFields,
  ProductSeriesDetailMosaicMediaGalleryProps,
} from '../types/productSeriesDetailMosaicMediaGallery.types';
import { TGalleryItem } from '../../../types/media.types';
import { imageRenditionsByPosition } from '../../../constants/mosiacRenditions.constants';
import { getThumbnailProps } from '../../../utils/youtube.utils';
import { appendRootToRichTextInternalLinks } from '../../../utils/appendRootToRichTextInternalLinks.utils';

export class ProductSeriesDetailMosaicMediaGalleryModel {
  private readonly fields?: ProductSeriesDetailMosaicMediaGalleryFields;
  private readonly rendering?: ComponentRendering;

  constructor(props: ProductSeriesDetailMosaicMediaGalleryProps) {
    this.fields = props?.fields;
    this.rendering = props?.rendering;
  }

  get thumbnailEE(): string {
    return this.fields?.itemData?.thumbnail || '';
  }

  get componentName(): string {
    return this.rendering?.componentName || '';
  }

  get eyebrow(): string {
    return this.fields?.apiData?.eyebrow || '';
  }

  get title(): string {
    return this.fields?.apiData?.title || '';
  }

  get description(): string {
    return appendRootToRichTextInternalLinks(this.fields?.apiData?.description) || '';
  }

  get items(): TGalleryItem[] {
    const maxAssets = this.fields?.apiData?.assets?.slice(0, 12) || [];
    if (!maxAssets.length) return [];
    const allCardsRenditionObj = imageRenditionsByPosition[maxAssets.length];
    return maxAssets?.map((item: ProductSeriesDetailMosaicMediaGalleryAsset, index: number) => {
      if (!item) return {};

      const deskRendionKey = allCardsRenditionObj[index + 1]['dskRenditionKey'];
      const mblRendionKey = allCardsRenditionObj[index + 1]['mblRenditionKey'];
      const youtubeThumbNail = item.role === 'extvideo' ? getThumbnailProps(item.full || '')?.thumbnailImgSrc || '' : '';

      return {
        title: {
          value: item.title,
        },
        description: {
          value: item.description,
        },
        mosaicItemProductImageProps: {
          desktopRendition: item[deskRendionKey],
          mobileRendition: item[mblRendionKey],
          ...(item.role === 'extvideo' && { desktopRendition: { url: youtubeThumbNail } }),
          alt: item.alt,
        },
        mosaicModalProductImageProps: {
          desktopRendition: item['rendition_desktop_size1100'],
          mobileRendition: item['rendition_mobile_size500'],
          ...(item.role === 'extvideo' && { desktopRendition: { url: youtubeThumbNail } }),
          alt: item.alt,
        },
        isVideo: item.role === 'video' || item.role === 'extvideo',
        get videoUrl(): string {
          if (this.isVideo && item.full) {
            return item.full;
          }
          return '';
        },
      } as TGalleryItem;
    });
  }

  get isUnreleased(): boolean {
    return !!this.fields?.isComponentUnreleased;
  }
}
